import { motion } from 'framer-motion';
import styled from 'styled-components';

export const StyledOnboardingScreenFtuxWrapper = styled(motion.div)`
    display: flex;
    height: 100vh;
    width: 100%;
    padding: 10px;
    display: flex;
    align-items: center;
    gap: 40px;
    flex-wrap: wrap-reverse;
    box-sizing: border-box;
    position: absolute;
    background: ${(p) => p.theme.colors.white};
    /* background-image: radial-gradient(${(p) => p.theme.colors.mutedTransparent} 2px, transparent 0); */
    /* background-size: 27px 27px; */
    /* background-position: -19px -19px; */
`;

export const StyledOnboardingScreenFtuxItem = styled(motion.div)`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: end;
    gap: 40px;
    padding-left: 40px;
    margin: 70px 0;
    min-height: 350px;
    min-width: 300px;
    box-sizing: border-box;
    overflow: hidden;
`;

export const StyledOnboardingScreenFtuxImageBg = styled(StyledOnboardingScreenFtuxItem)`
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, ${(p) => p.theme.colors.loopEmerald} 0%, #013329 100%);
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    margin: 0;
    padding: 0;
    overflow: hidden;
    position: relative;
    flex: 1;
`;

export const StyledOnboardingScreenImage = styled(motion.img)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const StyledRowItems = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const StyledOnboardingScreenItemHeader = styled(motion.div)`
    display: flex;
    flex-direction: column;
    gap: 40px;
    width: 100%;
    flex: 0 0 100%;
`;

export const StyledOnboardingScreenItemHeaderBadgeWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StyledOnboardingScreenItemColumn = styled(motion.div)`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const StyledOnboardingScreenCarousel = styled.div`
    & > div > span {
        width: 8px;
        height: 8px;
    }
`;

export const StyledOnboardingScreenItemHeaderBadge = styled.div`
    border-radius: 50px;
    padding: 4px 12px;
    background-color: ${(p) => p.theme.colors.mutedTransparent};
    width: fit-content;
`;

export const StyledOnboardingScreenCTA = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    width: fit-content;
`;
